export function mapGetters(arg) {
  return Vuex.mapGetters(arg)
}
export function mapState(...arg) {
  return Vuex.mapState(...arg)
}